export const getUserInitials = (user) => {
  if (user?.fullName) {
    return user.fullName.split(' ').map(n => n[0]).join('').toUpperCase();
  }
  if (user?.email) {
    return user.email.substring(0, 2).toUpperCase();
  }
  return 'U';
};

export const getUserDisplayName = (user) => {
  return user?.fullName || user?.email || 'User';
};
